import type { StepKey } from "@/core/types";

export interface CourseProgress {
  /** Alle bereits abgeschlossenen Schritte. */
  completedSteps: StepKey[];
  /** Zuletzt geöffnete Lektion, um den Kurs an derselben Stelle fortzusetzen. */
  lastLessonKey?: string;
  /** Zeitpunkt der letzten Änderung (ISO-String). */
  updatedAt?: string;
}

export const emptyProgress: CourseProgress = { completedSteps: [] };

/**
 * Speicher für den Kursfortschritt.
 *
 * Aktuell wird ausschließlich lokal gespeichert. Sobald Konten und Bezahlung
 * dazukommen, wird an dieser Stelle eine Implementierung ergänzt, die den
 * Fortschritt über eine API mit dem Benutzerkonto synchronisiert – der Rest der
 * Anwendung muss dafür nicht angepasst werden.
 */
export interface ProgressStore {
  load(courseId: string): Promise<CourseProgress>;
  save(courseId: string, progress: CourseProgress): Promise<void>;
  reset(courseId: string): Promise<void>;
}
